<template>
  <b-container>
    <div role="group" class="multi-select-wrapper">
      <label class="label" for="dropdown-form">{{ label }}</label>
      <div class="input-btn" @click="showDropdown">
        <p class="placeholder">{{ placeholder }}</p>
        <font-awesome-icon icon="fa-solid fa-chevron-down" />
      </div>
      <b-dropdown id="dropdown-form" text="Dropdown with form" ref="dropdown" :class="{ show: false }">
        <b-dropdown-form>
          <b-form-checkbox class="multi-checkbox" v-model="selectAll" @change="toggleSelectAll">
            Összes kiválasztása
          </b-form-checkbox>

          <b-dropdown-divider></b-dropdown-divider>
          <b-form-checkbox-group
            v-model="selected"
            class="d-flex flex-column"
            value-field="item"
            text-field="name"
            disabled-field="notEnabled"
          >
            <b-form-checkbox
              class="mb-3 multi-checkbox"
              v-for="option in options"
              :key="option.name"
              :value="option.item"
            >
              {{ option.name }}
            </b-form-checkbox>
          </b-form-checkbox-group>
        </b-dropdown-form>
      </b-dropdown>
    </div>
  </b-container>
</template>

<script>
export default {
  props: {
    label: { type: String, required: true },
    placeholder: { type: String, required: true },
    options: { type: Array, required: true },
    preSelection: { type: Array }
  },
  data() {
    return {
      optionsOpen: false,
      selected: [],
      selectAll: false
    }
  },
  methods: {
    toggleOptionsOpen() {
      this.optionsOpen = !this.optionsOpen
    },
    toggleSelectAll() {
      if (this.selected.length === this.options.length && this.selectAll === true) {
        this.selected = []
      } else {
        this.selected = this.options.map(option => option.item)
      }
    },
    showDropdown() {
      this.$refs.dropdown.show()
    }
  },
  watch: {
    selected(value) {
      if (value.length !== this.options.length && this.selectAll) {
        this.selectAll = false
      }
      if (value.length === this.options.length) {
        this.selectAll = true
      }
      this.$emit('on-item-select', value)
    }
  },
  mounted() {
    if (this.preSelection.length > 0) {
      this.selected = [...this.preSelection]
    }
  }
}
</script>

<style lang="scss">
.multi-select-wrapper {
  padding-inline: 0;
}
.multi-select-wrapper > * {
  text-align: left !important;
  font-size: 16px;
}

/* Local overrides */
.multi-select-wrapper {
  .btn.dropdown-toggle.btn-secondary {
    display: none;
  }
  .dropdown-menu.show {
    width: 100%;
    position: unset !important;
    transform: unset !important;
    will-change: unset !important;
  }
  .btn-group {
    width: 100%;
  }
}

/* My styles */
.multi-select-wrapper {
  .label {
    width: 100%;
    padding: 0;
    color: #000;
    font-weight: 700;
    font-size: 12px;
    cursor: pointer;
  }

  .multi-checkbox > * {
    cursor: pointer;
    color: #2d3436;
    font-weight: 500;
    font-size: 14px;
  }
  .multi-checkbox > label {
    padding-top: 3px;
    padding-bottom: 3px;
  }

  .input-btn {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 36px;
    border-radius: 4px;
    border: 1px solid #bbc1d3;
    padding: 8px;
    cursor: pointer;
  }

  .placeholder {
    margin: 0;
    font-weight: 400;
    font-size: 14px;
    color: #636e72;
  }

  .options-container {
    border: 1px solid #dfe2ea;
  }
}
</style>
